export default "__VITE_ASSET__C_E43MuA__"